import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AuthorPage } from '../author/author.page.js';
import { RdAuthorMainMbOrgan } from '../../atomics/organs/rd-author-main-mb/rd-author-main-mb.organ.js';
import { RdAuthorTabPageMbOrgan } from '../../atomics/organs/rd-author-tab-page-mb/rd-author-tab-page-mb.organ.js';

@Component({
  standalone: true,
  selector: 'ui-author-desktop',
  imports: [CommonModule, RdAuthorMainMbOrgan, RdAuthorTabPageMbOrgan],
  templateUrl: './author-desktop.page.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthorDesktopPage extends AuthorPage { }
